import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "@/lib/api";
import { DnaBackground } from "@/components/DnaBackground";
import { Hero } from "@/components/Hero";
import { Comparison } from "@/components/Comparison";
import { Pricing } from "@/components/Pricing";
import { CTA } from "@/components/CTA";
import { LandingNavigation } from "@/components/LandingNavigation";

const Index = () => {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = getUserData();
    setUser(userData);
  }, [navigate]);

  return (
    <div className="relative">
      <DnaBackground />
      <LandingNavigation />
      <Hero />
      <div id="how-it-works">
        <Comparison />
      </div>
      <CTA />
      <div id="pricing">
        <Pricing />
      </div>
    </div>
  );
};

export default Index;
